// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutomationSchedule } from './AutomationSchedule';
import {
    AutomationScheduleFromJSON,
    AutomationScheduleFromJSONTyped,
    AutomationScheduleToJSON,
    AutomationScheduleToJSONTyped,
} from './AutomationSchedule';
import type { AutomationFunction } from './AutomationFunction';
import {
    AutomationFunctionFromJSON,
    AutomationFunctionFromJSONTyped,
    AutomationFunctionToJSON,
    AutomationFunctionToJSONTyped,
} from './AutomationFunction';

/**
 * 
 * @export
 * @interface Automation
 */
export interface Automation {
    /**
     * Room ID where automation is active
     */
    roomId: string;
    /**
     * Device ID for the automation
     */
    deviceId: string;
    /**
     * Automation name
     */
    name: string;
    /**
     * Automation description
     */
    description?: string;
    /**
     * Indicates if automation is enabled
     */
    enabled?: boolean;
    /**
     * 
     */
    schedule: AutomationSchedule;
    /**
     * 
     */
    targetFunction: AutomationFunction;
    /**
     * Unique automation ID
     */
    id: string;
    /**
     * 
     */
    createdAt: Date;
    /**
     * 
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the Automation interface.
 */
export function instanceOfAutomation(value: object): value is Automation {
    if (!('roomId' in value) || value['roomId'] === undefined) return false;
    if (!('deviceId' in value) || value['deviceId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('schedule' in value) || value['schedule'] === undefined) return false;
    if (!('targetFunction' in value) || value['targetFunction'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    return true;
}

export function AutomationFromJSON(json: any): Automation {
    return AutomationFromJSONTyped(json, false);
}

export function AutomationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Automation {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['roomId'],
        'deviceId': json['deviceId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'schedule': AutomationScheduleFromJSON(json['schedule']),
        'targetFunction': AutomationFunctionFromJSON(json['targetFunction']),
        'id': json['id'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function AutomationToJSON(json: any): Automation {
    return AutomationToJSONTyped(json, false);
}

export function AutomationToJSONTyped(value?: Automation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomId': value['roomId'],
        'deviceId': value['deviceId'],
        'name': value['name'],
        'description': value['description'],
        'enabled': value['enabled'],
        'schedule': AutomationScheduleToJSON(value['schedule']),
        'targetFunction': AutomationFunctionToJSON(value['targetFunction']),
        'id': value['id'],
        'created_at': value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

